import { useEffect } from 'react';

const WithBodyClickClose: React.FC<{
    id?: string;
    children: React.ReactElement;
    closeMe: () => void;
}> = ({ id, children, closeMe }) => {
    useEffect(() => {
        const t = (e: MouseEvent) => {
            const dialog = document.getElementById(id || 'dialog');
            if (!dialog) {
                return;
            }

            if (
                // Looks like e.path is deprecated / not avaiable in all browsers
                // TODO remove it
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                (e?.path && !e?.path?.includes(dialog)) ||
                !e?.composedPath()?.includes(dialog)
            ) {
                closeMe();
            }
        };

        document.body.addEventListener('click', t);

        return () => {
            document.body.removeEventListener('click', t);
        };
    }, []);
    return children;
};

export default WithBodyClickClose;
